import { mapActions, mapGetters, mapState } from 'vuex'
import Indicator from '@/shared/directives/indicator.js'

export default {
  directives: { Indicator },
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('landing', ['currentView']),
    ...mapGetters('landing', ['isActive', 'objectById']),
    current() {
      return this.objectById(this.id)
    },
    options() {
      return this.current.options[this.currentView]
    },
    parentId() {
      return this.current.path ? this.current.path[this.current.path.length - 1] : null
    },
  },
  methods: mapActions('landing', ['setActive', 'pastePanel']),
}
